module.exports = __webpack_public_path__ + "static/famprofile-a632c34c45e8b0f3dc39d51018a303e4.svg";